@if (form) {
<div class="flex md:items-center md:justify-center">
  <div class="p-4 w-full h-auto md:max-w-3xl bg-white rounded-xl shadow-sm" [formGroup]="form">

    <!-- Avatar + nombre -->
    <div class="relative flex flex-col items-center mt-2">
      <app-metro-upload-images [initialImageUrl]="imagePreviewUrl" (imageSelected)="onImageSelected($event)"
        (validationError)="onImageValidationError($event)">
      </app-metro-upload-images>

      <h3 class="mt-2 font-semibold text-lg text-metrodev-blue">
        {{ userData?.name || '' }}
      </h3>
      <p class="text-sm text-gray-500">
        {{ userData?.email || '' }}
      </p>
    </div>

    <!-- Información personal -->
    <div class="mt-2">
      <h3 class="font-semibold text-metro-blue-secondary text-base">
        {{'::PersonalInformation' | abpLocalization}}
      </h3>


      <div class="flex flex-col gap-2">
        <app-metro-form-input formControlName="name" />
        <app-metro-form-input formControlName="surname" />
        <app-metro-form-input formControlName="documentNumber" placeholder="DNI" />
      </div>

      @if (isSommelier) {
      <div class="flex flex-col gap-2 mt-2">
        <app-metro-form-input formControlName="bio" [placeholder]='"::Bio" | abpLocalization' size="md" type="text" />

        <app-metro-form-input formControlName="country" [placeholder]='"::Country" | abpLocalization' size="md"
          type="text" />

        <app-metro-form-input formControlName="region" [placeholder]='"::Region" | abpLocalization' size="md"
          type="text" />

        <app-metro-form-input formControlName="city" [placeholder]='"::City" | abpLocalization' size="md" type="text" />

        <app-metro-form-input formControlName="specialities" [placeholder]='"::Specialities" | abpLocalization'
          size="md" type="text" />

        <app-metro-form-input formControlName="certification" [placeholder]='"::Certification" | abpLocalization'
          size="md" type="text" />

        <app-metro-form-input formControlName="paymentAccountDetails" name="payment-account-details"
          [placeholder]='"::PaymentAccountDetails" | abpLocalization' size="md" type="text" />
      </div>
      }

      <input type="text" name="username" autocomplete="username" tabindex="-1" aria-hidden="true"
        class="absolute opacity-0 pointer-events-none h-0 w-0" />

      <input type="password" name="password" autocomplete="current-password" tabindex="-1" aria-hidden="true"
        class="absolute opacity-0 pointer-events-none h-0 w-0" />


      @if (changePassword) {
      }

      <div class="mt-1">
        <button type="button" class="text-sm text-metro-blue hover:underline" (click)="toggleChangePassword()">
          {{ changePassword ? ('::CancelChangePassword' | abpLocalization) : ('::ChangePassword' | abpLocalization) }}
        </button>
      </div>

      @if (changePassword) {
      <div class="mt-2 space-y-4">
        <div>
          <app-metro-form-input formControlName="currentPassword" [placeholder]='"::CurrentPassword" | abpLocalization'
            size="md" type="password">
          </app-metro-form-input>
        </div>

        <div>
          <app-metro-form-input formControlName="newPassword" [placeholder]='"::NewPassword" | abpLocalization'
            size="md" type="password">
          </app-metro-form-input>
        </div>
      </div>
      }
    </div>

    <!-- Información de contacto -->
    <div class="mt-2">
      <h3 class="font-semibold text-metro-blue-secondary text-base">
        {{ '::ContactInformation' | abpLocalization }}
      </h3>

      <div class="flex flex-col gap-2">
        <app-metro-form-input formControlName="email" [label]='"::Email" | abpLocalization' [placeholder]='"::Email" | abpLocalization' size="md"
          type="email"></app-metro-form-input>
        <app-metro-form-input formControlName="phoneNumber" [label]='"::Telephone" | abpLocalization' [placeholder]='"::Telephone" | abpLocalization' size="md"
          type="tel" appArMobileMask></app-metro-form-input>
        <app-metro-form-input formControlName="address" [label]='"::Address" | abpLocalization' [placeholder]='"::Address" | abpLocalization' size="md"
          type="text"></app-metro-form-input>
        <app-metro-form-select formControlName="province" [label]='"::Province" | abpLocalization' [placeholder]='"::Province" | abpLocalization'
          [options]="provinceOptions" [allowSearch]="false" [allowClear]="false" size="md"></app-metro-form-select>
      </div>
    </div>

    <!-- Preferencias / Pickups (solo para sommeliers) -->
    @if (isSommelier) {
    <div class="mt-2">
      <span class="font-semibold text-metro-blue-secondary text-base">
        {{'::Preferences' | abpLocalization}}
      </span>

      <app-metro-form-select [multiple]="true" [options]="pickups$ | async" formControlName="pickupIds"
        [placeholder]="'::PickupPoints' | abpLocalization" size="md" selectedBackgroundClass="bg-gray-500"
        [allowSearch]="false">
      </app-metro-form-select>
    </div>
    }

    <!-- Mi Sommelier (solo clientes) -->
    @if (!isSommelier) {
    <div class="mt-4">
      <h3 class="font-semibold text-metro-blue-secondary text-base">
        {{ '::MySommelier' | abpLocalization }}
      </h3>
      <a [routerLink]="['/', slug, 'my-sommelier']"
        class="mt-2 block border border-gray-200 rounded-xl p-4 no-underline hover:bg-gray-50 transition">
        <span class="block text-sm text-gray-600">{{ '::MySommelier:Intro' | abpLocalization }}</span>
        <span class="mt-2 block text-metrodev-blue font-semibold">{{ '::MySommelier:Change' | abpLocalization }} ›</span>
      </a>
    </div>
    }

    <!-- Botón -->
    <div class="mt-8 flex justify-center">
      <button class="w-full bg-metro-blue text-metro-secondary py-2 rounded-md font-medium hover:opacity-90 transition"
        (click)="onSave()" [disabled]="isLoading">
        {{ isLoading ? ('::Saving' | abpLocalization) : ('::SaveChanges' | abpLocalization) }}
      </button>
    </div>
  </div>
</div>
}